import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Episodes from "@/pages/Episodes";
import BeAGuest from "@/pages/BeAGuest";
import Media from "@/pages/Media";
import Contact from "@/pages/Contact";
import Sponsorship from "@/pages/Sponsorship";
import Merch from "@/pages/Merch";
import Book from "@/pages/Book";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import ScrollToTop from "@/components/layout/ScrollToTop";
import VisitTracker from "@/components/analytics/VisitTracker";

function ChromeWrap({ children }) {
  const location = useLocation();
  const hideChrome =
    location.pathname.startsWith("/admin") ||
    location.hash?.includes("session_id=");
  return (
    <>
      {!hideChrome && <Navbar />}
      <main>{children}</main>
      {!hideChrome && <Footer />}
    </>
  );
}

function AppRouter() {
  const location = useLocation();

  // Detect OAuth callback SYNCHRONOUSLY during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <ChromeWrap>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/episodes" element={<Episodes />} />
        <Route path="/be-a-guest" element={<BeAGuest />} />
        <Route path="/media" element={<Media />} />
        <Route path="/sponsorship" element={<Sponsorship />} />
        <Route path="/merch" element={<Merch />} />
        <Route path="/book" element={<Book />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </ChromeWrap>
  );
}

function App() {
  useEffect(() => {
    document.title = "Prove Your Point Podcast · Hosted by Manuel Santana";
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <VisitTracker />
        <AppRouter />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              border: "1px solid #E10600",
              borderRadius: 0,
              color: "#FFFFFF",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
